import { Box, Container, Flex, Heading, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LEGAL_HISTORY } from "../../utils/legalDate";

// Archiwum dokumentów prawnych — wszystkie wersje z okresami obowiązywania
const LegalArchive = () => {
    const { i18n } = useTranslation();
    const en = i18n.language?.startsWith('en');

    return (
        <Box w="full">
            <Container maxW="7xl" py={{ base: '40px', md: '64px' }}>
                <Heading as="h1" fontSize={{ base: '28px', md: '36px' }} fontWeight={700} letterSpacing="-0.6px" mb="8px">
                    {en ? 'Legal document archive' : 'Archiwum dokumentów prawnych'}
                </Heading>
                <Text color="#6E6064" fontSize="15px" mb="32px">
                    {en
                        ? 'Current and previous versions of the Evenado platform documents with their effective periods.'
                        : 'Obowiązujące i poprzednie wersje dokumentów platformy Evenado wraz z okresami ich obowiązywania.'}
                </Text>
                <Flex direction="column" gap="16px">
                    {Object.entries(LEGAL_HISTORY).map(([doc, h]) => (
                        <Box key={doc} bg="white" border="1px solid #ECE4E4" borderRadius="18px" p={{ base: '18px', md: '24px' }}>
                            <Heading as="h2" fontSize="20px" fontWeight={700} mb="12px">{en ? h.titleEn : h.titlePl}</Heading>
                            <Flex direction="column" gap="8px">
                                {h.versions.map((v, idx) => (
                                    <Flex key={v.version} gap="10px" align="center" flexWrap="wrap" fontSize="15px">
                                        <Text as={RouterLink} to={v.path} color="#7A1F35" fontWeight={700} textDecoration="underline">
                                            {en ? `Version ${v.version}` : `Wersja ${v.version}`}
                                        </Text>
                                        <Text color="#4B3F42">
                                            {v.to
                                                ? (en ? `effective ${v.from} – ${v.to}` : `obowiązywała ${v.from} – ${v.to}`)
                                                : (en ? `effective from ${v.from}` : `obowiązuje od ${v.from}`)}
                                        </Text>
                                        {idx === 0 && (
                                            <Text as="span" fontSize="12px" fontWeight={700} color="#5C1628" bg="#F5E4E9" px="10px" py="2px" borderRadius="full">
                                                {en ? 'current' : 'obowiązująca'}
                                            </Text>
                                        )}
                                    </Flex>
                                ))}
                            </Flex>
                        </Box>
                    ))}
                </Flex>
            </Container>
        </Box>
    );
};

export default LegalArchive;
